export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const signupGroupSmallImg = require("../assets/group1.png");
export const signupGroupLargeImg = require("../assets/group2.png");